import { memo } from 'react';
import classnames from 'clsx';
import { Tab as ReactTabsTab } from 'react-tabs';

import style from './tab.module.css';

import type { TabProps } from 'react-tabs';
import type { ReactTabsMemoComponent } from 'ui-components/components/tabs/tabs-types';

/**
 * @deprecated Use `Tabs.Tab` from `@mantine/core` instead.
 * See: ui-components/readme-documentation/MIGRATION.md
 */
export const Tab: ReactTabsMemoComponent<TabProps> = memo(({ children, className, selectedClassName, ...rest }) => (
  <ReactTabsTab
    className={classnames(style.tab, className)}
    selectedClassName={classnames(style['selected-tab'], selectedClassName)}
    tabIndex='0'
    {...rest}
  >
    {children}
  </ReactTabsTab>
));

Tab.displayName = 'Tab';
Tab.tabsRole = 'Tab';
